// Create Purchase Approval Constants
export const CREATE_PURCHASE_APPROVAL_REQUEST = "CREATE_PURCHASE_APPROVAL_REQUEST"
export const CREATE_PURCHASE_APPROVAL_SUCCESS = "CREATE_PURCHASE_APPROVAL_SUCCESS"
export const CREATE_PURCHASE_APPROVAL_FAIL = "CREATE_PURCHASE_APPROVAL_FAIL"
export const CREATE_PURCHASE_APPROVAL_RESET = "CREATE_PURCHASE_APPROVAL_RESET"

// Get All Purchase Approvals Constants
export const GET_ALL_PURCHASE_APPROVALS_REQUEST = "GET_ALL_PURCHASE_APPROVALS_REQUEST"
export const GET_ALL_PURCHASE_APPROVALS_SUCCESS = "GET_ALL_PURCHASE_APPROVALS_SUCCESS"
export const GET_ALL_PURCHASE_APPROVALS_FAIL = "GET_ALL_PURCHASE_APPROVALS_FAIL"

// Get Purchase Approval By ID Constants
export const GET_PURCHASE_APPROVAL_REQUEST = "GET_PURCHASE_APPROVAL_REQUEST"
export const GET_PURCHASE_APPROVAL_SUCCESS = "GET_PURCHASE_APPROVAL_SUCCESS"
export const GET_PURCHASE_APPROVAL_FAIL = "GET_PURCHASE_APPROVAL_FAIL"
export const GET_PURCHASE_APPROVAL_RESET = "GET_PURCHASE_APPROVAL_RESET"

// Approve Purchase Constants
export const APPROVE_PURCHASE_REQUEST = "APPROVE_PURCHASE_REQUEST"
export const APPROVE_PURCHASE_SUCCESS = "APPROVE_PURCHASE_SUCCESS"
export const APPROVE_PURCHASE_FAIL = "APPROVE_PURCHASE_FAIL"
export const APPROVE_PURCHASE_RESET = "APPROVE_PURCHASE_RESET"

// Reject Purchase Constants
export const REJECT_PURCHASE_REQUEST = "REJECT_PURCHASE_REQUEST"
export const REJECT_PURCHASE_SUCCESS = "REJECT_PURCHASE_SUCCESS"
export const REJECT_PURCHASE_FAIL = "REJECT_PURCHASE_FAIL"
export const REJECT_PURCHASE_RESET = "REJECT_PURCHASE_RESET"

// Delete Purchase Approval Constants
export const DELETE_PURCHASE_APPROVAL_REQUEST = "DELETE_PURCHASE_APPROVAL_REQUEST"
export const DELETE_PURCHASE_APPROVAL_SUCCESS = "DELETE_PURCHASE_APPROVAL_SUCCESS"
export const DELETE_PURCHASE_APPROVAL_FAIL = "DELETE_PURCHASE_APPROVAL_FAIL"
export const DELETE_PURCHASE_APPROVAL_RESET = "DELETE_PURCHASE_APPROVAL_RESET"

// Delete Product From Approval Constants
export const DELETE_PRODUCT_FROM_APPROVAL_REQUEST = "DELETE_PRODUCT_FROM_APPROVAL_REQUEST"
export const DELETE_PRODUCT_FROM_APPROVAL_SUCCESS = "DELETE_PRODUCT_FROM_APPROVAL_SUCCESS"
export const DELETE_PRODUCT_FROM_APPROVAL_FAIL = "DELETE_PRODUCT_FROM_APPROVAL_FAIL"
export const DELETE_PRODUCT_FROM_APPROVAL_RESET = "DELETE_PRODUCT_FROM_APPROVAL_RESET"

// Add these new constants for updating products in approval
export const UPDATE_APPROVAL_PRODUCTS_REQUEST = "UPDATE_APPROVAL_PRODUCTS_REQUEST"
export const UPDATE_APPROVAL_PRODUCTS_SUCCESS = "UPDATE_APPROVAL_PRODUCTS_SUCCESS"
export const UPDATE_APPROVAL_PRODUCTS_FAIL = "UPDATE_APPROVAL_PRODUCTS_FAIL"
export const UPDATE_APPROVAL_PRODUCTS_RESET = "UPDATE_APPROVAL_PRODUCTS_RESET"

// Add to purchaseApprovalConstant.js
export const GET_FILTERED_PURCHASE_APPROVALS_REQUEST = "GET_FILTERED_PURCHASE_APPROVALS_REQUEST";
export const GET_FILTERED_PURCHASE_APPROVALS_SUCCESS = "GET_FILTERED_PURCHASE_APPROVALS_SUCCESS";
export const GET_FILTERED_PURCHASE_APPROVALS_FAIL = "GET_FILTERED_PURCHASE_APPROVALS_FAIL";
// purchaseApprovalConstants.js
export const RESET_PURCHASE_APPROVALS = 'RESET_PURCHASE_APPROVALS';

// Clear Errors
export const CLEAR_ERRORS = "CLEAR_ERRORS"

